import React from 'react';
import CanvasWrapper from './components/CanvasWrapper';
import ImprovedNoiseParticles from './components/particles/ImprovedNoiseParticles';

const SplineScene: React.FC = () => (
    <CanvasWrapper>
        <ImprovedNoiseParticles count={2000} />
    </CanvasWrapper>
);

export default SplineScene;